import React, { Component } from 'react';
import { Row, Container, Col, Form, Button, Modal, Spinner, Table } from "react-bootstrap";

export default class MultipleChemoPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            

        };
        this.radioChange = this.radioChange.bind(this);
    }
    radioChange(event) {
        if(event.target.value==='Other'){
            this.setState({ showCommentBox: true });
            this.setState({'terminationComments':null});
        }else{
            this.setState({ showCommentBox: false });
            this.setState({'terminationComments':event.target.value});
        }
    }
    render() {
        const { showMultipleChemoPopup, closeModal} = this.props;
        const closePreviewModal = () => {
            closeModal();
        }
        return (
            <div>
                <Modal id="report" show={showMultipleChemoPopup} centered animation={true} scrollable={true} size="xl">
                    <Modal.Header closeButton onClick={() => closePreviewModal()}>
                        <Modal.Title>
                            <h3 className="fs-18 header_title mb-0 text-black">Choose Protocol</h3></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container fluid>
                            <Row>
                                <Col lg='12'>
                                    <Table striped bordered hover size="sm">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Treatment Plan</th>
                                                <th>Previous Cycle Date</th>
                                                <th>Upcoming Cycle Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                            <td><Form.Check name="groupThree" type="radio" className="pl-0" onChange={this.radioChange} value="Treatment completed as per plan"/></td>
                                            <td>Treatment Plan 1</td>
                                            <td>NA</td>
                                            <td></td>
                                            </tr>
                                            <tr>
                                            <td><Form.Check name="groupThree" type="radio" className="pl-0" onChange={this.radioChange} value="Treatment completed as per plan"/></td>
                                            <td>Treatment Plan 2</td>
                                            <td>NA</td>
                                            <td></td>
                                            </tr>
                                            <tr>
                                            <td><Form.Check name="groupThree" type="radio" className="pl-0" onChange={this.radioChange} value="Treatment completed as per plan"/></td>
                                            <td>Treatment Plan 3</td>
                                            <td>NA</td>
                                            <td></td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer className='text-center'>
                        <Button className="btn btn-secondary"> 
                            {this.state.saveLoader && (
                                <Spinner className='mr-2' animation='border' size='1.5rem' />
                            )}
                            Confirm 
                        </Button>
                        <Button variant="outline-danger" onClick={() => closePreviewModal()}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}